import axios from "axios";
import qs from "querystring";

import ToastService from "../service/toast-service";
import { SERVER_BASE_URL } from "../config";

const createNewRoom = async ({ roomName }) => {
  const url = `${SERVER_BASE_URL}/server/create?${qs.stringify({
    roomName,
  })}`;
  const {
    data: { payload: roomId, error, info },
  } = await axios.get(url, { withCredentials: true });

  if (error) {
    ToastService.errorToast(error);
    return false;
  }
  if (info) ToastService.infoToast(info);

  if (roomId) return roomId;

  return null;
};

const joinRoom = async ({ roomId }) => {
  const url = `${SERVER_BASE_URL}/server/join?${qs.stringify({
    roomId,
  })}`;
  const {
    data: { payload, error, info },
  } = await axios.get(url, { withCredentials: true });

  if (error) {
    ToastService.errorToast(error);
    return false;
  }
  if (info) ToastService.infoToast(info);

  if (payload) return payload;

  return null;
};

const fetchRoom = async ({ roomId }) => {
  const url = `${SERVER_BASE_URL}/server/room?${qs.stringify({
    roomId,
  })}`;
  const {
    data: { payload, error, info },
  } = await axios.get(url, { withCredentials: true });

  if (error) {
    ToastService.errorToast(error);
    return false;
  }
  if (info) ToastService.infoToast(info);

  return payload;
};

const leaveRoom = async ({ roomId }) => {
  const url = `${SERVER_BASE_URL}/server/leave?${qs.stringify({
    roomId,
  })}`;
  const {
    data: { payload, error, info },
  } = await axios.get(url, { withCredentials: true });

  if (error) {
    ToastService.errorToast(error);
    return false;
  }
  if (info) ToastService.infoToast(info);

  if (payload) return true;
};

const syncRoom = async ({ roomId }) => {
  const url = `${SERVER_BASE_URL}/server/sync?${qs.stringify({
    roomId,
  })}`;
  const {
    data: { payload, error, info },
  } = await axios.get(url, { withCredentials: true });

  if (error) {
    ToastService.errorToast(error);
    return false;
  }
  if (info) ToastService.infoToast(info);

  console.log("payload", payload);

  return payload;
};

const fetchAllRooms = async () => {
  const url = `${SERVER_BASE_URL}/server/rooms`;
  const {
    data: { payload, error, info },
  } = await axios.get(url, { withCredentials: true });

  if (error) {
    ToastService.errorToast(error);
    return false;
  }
  if (info) ToastService.infoToast(info);
  return payload;
};

const add = async ({ roomId, songs }) => {
  const url = `${SERVER_BASE_URL}/server/room`;
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    withCredentials: true,
  };
  const body = {
    roomId,
    songs: JSON.stringify(songs),
  };
  const {
    data: { payload, error, info },
  } = await axios.post(url, qs.stringify(body), config);
  if (error) ToastService.errorToast(error);
  if (info) ToastService.infoToast(info);
  return payload;
};

const removeSong = async ({ roomId, index }) => {
  const url = `${SERVER_BASE_URL}/server/room/remove?${qs.stringify({
    index,
    roomId,
  })}`;
  const {
    data: { payload, error, info },
  } = await axios.get(url, { withCredentials: true });
  if (error) ToastService.errorToast(error);
  if (info) ToastService.infoToast(info);
  return payload;
};

const update = async ({ roomId, name, queue, theme }) => {
  const url = `${SERVER_BASE_URL}/server/room/update`;
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    withCredentials: true,
  };
  const body = {
    roomId,
    name,
    queue: queue && JSON.stringify(queue),
    theme,
  };
  const {
    data: { error, info, payload },
  } = await axios.post(url, qs.stringify(body), config);
  if (error) ToastService.errorToast(error);
  if (info) ToastService.infoToast(info);
  return payload;
};

export default {
  createNewRoom,
  joinRoom,
  leaveRoom,
  fetchRoom,
  syncRoom,
  fetchAllRooms,
  add,
  update,
  removeSong,
};
